<div class="card height-100 p-mt-3">
    <div class="p-grid divider-bottom p-pt-2 p-ai-center">
        <div class="p-col-5 p-text-secondary">
            <div class="p-header-font-size">
                Booking Number
            </div>
            <div class="p-mt-1 p-text-bold p-cursor" (click)="handleClickActions('shipment-details', booking)">
                {{booking?.bookingId ? booking?.bookingId : '-'}}
            </div>
        </div>
        <div class="p-col-7">
            <div class="p-d-flex p-jc-end p-ai-center">
                <div [class]="booking?.status ? 'status-shape p-p-1' : ''"
                     [ngClass]="getColoredBookingStatus(booking?.status)">
                    {{booking?.status ? booking?.status : '-'}}
                </div>
                <div class="p-ml-2">
                    <i (click)="handleClickActions('menu', booking)"
                       class="pi pi-ellipsis-v p-text-primary p-text-bold p-cursor"
                       style="font-size: 1.65rem"></i>
                </div>
            </div>
        </div>
    </div>


    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Type
            </div>
            <div class="p-mt-1" [ngClass]="applyColorTextBaseOnType(booking?.shipmentType)">
                {{booking?.shipmentType ? booking?.shipmentType : '-'}}
            </div>
        </div>
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Customer Ref. No.
            </div>
            <div class="p-mt-1">
                {{booking?.customerReferenceNumber ? booking?.customerReferenceNumber : '-'}}
            </div>
        </div>
    </div>

    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Transport Document
            </div>
            <div class="p-mt-1">
                {{booking?.transportDocument ? booking?.transportDocument : '-'}} <span class="p-ml-2"
                                                                                        *ngIf="booking?.blCount > 0"> <p-badge
                    [value]="booking?.blCount"></p-badge></span>
            </div>
        </div>
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Booking Date
            </div>
            <div class="p-mt-1">
                {{booking?.bookingDate ? (booking?.bookingDate | date: 'dd-MMM-yyyy') : '-'}}
            </div>
        </div>
    </div>

    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Origin
            </div>
            <div class="p-mt-1">
                {{booking?.origin ? booking?.origin : '-'}}

            </div>
        </div>
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Destination
            </div>
            <div class="p-mt-1">
                {{booking?.destination ? booking?.destination : '-'}}
            </div>
        </div>
    </div>

    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Departure
            </div>
            <div class="p-mt-1"
                 [class]="booking?.actualDepartureBoolean ? 'p-text-success' : 'p-text-warning'">
                {{booking?.departureDate ? (booking?.departureDate | date: 'dd-MMM-yyyy') : '-'}}

            </div>
        </div>
        <div class="p-col-6">
            <div class="p-text-bold p-header-font-size p-text-secondary">
                Arrival
            </div>
            <div class="p-mt-1"
                 [class]="booking?.actualArrivalBoolean ? 'p-text-success' : 'p-text-warning'">
                {{booking?.arrivalDate ? (booking?.arrivalDate | date: 'dd-MMM-yyyy') : '-'}}
            </div>
        </div>
    </div>

</div>
